import { Cell, FormControl, Grid, Theme, useStyles, VFlow } from 'bold-ui'
import { useAlert } from 'components/alert'
import { toDate } from 'date-fns'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import { CSSProperties } from 'react'
import { dateAsYyyyMmDd } from 'util/date/formatDate'
import { MetaPath } from 'util/metaPath'

import { CiapPlanoModel } from '../model-plano'
import { PlanoFormProps } from '../PlanoForm'
import { CiapPlanoField, CiapPlanoProps } from './CiapPlanoField'
import { ProcedimentoPlanoField, ProcedimentoPlanoModel } from './ProcedimentoPlanoField'

export interface ProcedimentosPlanoModel {
  procedimentos?: ProcedimentoPlanoModel[]
  codigosProcedimentosAutomaticosExcluidos?: string[]
}
export interface IntervencoesProcedimentosPlanoModel {
  ciaps?: ReadonlyArray<CiapPlanoModel>
  procedimentosPlano?: ProcedimentosPlanoModel
}

interface IntervencoesProcedimentosViewProps
  extends Omit<CiapPlanoProps, 'name'>,
    Pick<PlanoFormProps, 'isAtendimentoOdonto' | 'isAtendimentoProcedimentos'> {
  name: MetaPath<IntervencoesProcedimentosPlanoModel>
  dataAtendimento: Instant
}

export function IntervencoesProcedimentosView(props: Readonly<IntervencoesProcedimentosViewProps>) {
  const { isAtendimentoOdonto, isAtendimentoProcedimentos, cidadao, name, dataAtendimento } = props
  const { classes } = useStyles(createStyles)
  const alert = useAlert()
  const { isRetificacao } = useAtendimentoContext()

  const alertProcedimentoAutomaticoAlterado = () => {
    alert(
      'info',
      'Um procedimento automático foi alterado na lista de intervenções e/ou procedimentos clínicos realizados.'
    )
  }

  return (
    <VFlow vSpacing={0}>
      <FormControl label='Intervenções e/ou procedimentos clínicos realizados' style={classes.heading}>
        <Grid>
          {!isAtendimentoOdonto && (
            <Cell size={12}>
              <CiapPlanoField name={name.ciaps} cidadao={cidadao} controlModifiedStatus={isRetificacao} />
            </Cell>
          )}
          <Cell size={12}>
            <ProcedimentoPlanoField
              name={name.procedimentosPlano}
              cidadao={cidadao}
              filtrarProcedimentosOdonto={isAtendimentoOdonto}
              dataAtendimento={dateAsYyyyMmDd(toDate(dataAtendimento))}
              onAutomaticChange={alertProcedimentoAutomaticoAlterado}
              required={isAtendimentoProcedimentos}
              controlModifiedStatus={isRetificacao}
            />
          </Cell>
        </Grid>
      </FormControl>
    </VFlow>
  )
}

const createStyles = (theme: Theme) => ({
  heading: {
    '> label': {
      ...theme.typography.variant('h3'),
    } as CSSProperties,
  } as CSSProperties,
})
